import { FC } from 'react';
import { Toggle, ToggleSize } from '@app/shared/components/toggle/Toggle';
import { useLocale } from '@app/core/hooks/useLocale';
import { FormProvider, useForm } from 'react-hook-form';
import { formConfigBase } from '@app/shared/constants/form-config-base';
import styles from './showhistoricdata.module.scss';

interface ShowHistoricDataToggleProps {
  checked: boolean | undefined;
  onToggle: (checked: boolean) => void;
  shouldShow?: boolean;
}

export const ShowHistoricDataToggle: FC<ShowHistoricDataToggleProps> = ({
  checked,
  onToggle,
  shouldShow = true,
}) => {
  const { l } = useLocale();
  const formMethods = useForm({
    ...formConfigBase,
  });

  if (!shouldShow) {
    return null;
  }

  const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(e.target.checked);
  };

  return (
    <FormProvider {...formMethods}>
      <Toggle
        name="isHistoricDataVisible"
        label={l('_ShowHistoricData')}
        toggleSize={ToggleSize.Medium}
        onChange={handleToggleChange}
        data-testid="historical-cash-value-toggle"
        className={styles['show-historic-data']}
        forceChecked={checked}
      />
    </FormProvider>
  );
};
